/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { usePhotoUploadProgress } from '@/Client/State/PhotoUploadProgressContext';

import { TYPOGRAPHY2 } from '../Styles';
import { Spinner } from './Spinner';

const INDICATOR_STYLE = css`
  label: PHOTO_UPLOAD_PROGRESS_INDICATOR_STYLE;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 50;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 6px;
  background: var(--background);
  border: 1px solid var(--border);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  ${TYPOGRAPHY2.smallBold}
  color: var(--text);
`;

/**
 * A bottom-right, always-in-the-same-place readout of an in-flight bulk photo
 * upload — dropped in from the file system or picked via a "+ Add" button, at
 * any scope. Renders nothing outside an upload (see PhotoUploadProgressContext).
 */
export const PhotoUploadProgressIndicator = () => {
  const progress = usePhotoUploadProgress();
  if (!progress) return null;
  const { completed, total } = progress;

  return (
    <div css={INDICATOR_STYLE} role='status' aria-live='polite'>
      <Spinner size={16} />
      <span>Uploading {completed} of {total} {total === 1 ? 'photo' : 'photos'}…</span>
    </div>
  );
};
